import { render, staticRenderFns } from "./ResetAssignedBusesByType.vue?vue&type=template&id=52143795&"
import script from "./ResetAssignedBusesByType.vue?vue&type=script&lang=js&"
export * from "./ResetAssignedBusesByType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports